import { render, staticRenderFns } from "./ManageWarehousesModal.vue?vue&type=template&id=67c68f70&scoped=true"
import script from "./ManageWarehousesModal.vue?vue&type=script&lang=js"
export * from "./ManageWarehousesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageWarehousesModal.vue?vue&type=style&index=0&id=67c68f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c68f70",
  null
  
)

export default component.exports